import {applyMiddleware, createStore} from 'redux';
import thunkMiddleware from 'redux-thunk';
import reducer from './reducers';
import {redirectMiddleware} from 'middlewares/redirect';
import {socketIoMiddleware} from 'middlewares/socket-io';
import {runSocketListener} from 'services/socket-io';
import {composeWithDevTools} from 'redux-devtools-extension';

const Store = composeWithDevTools(applyMiddleware(thunkMiddleware, redirectMiddleware, socketIoMiddleware))(
    createStore,
)(reducer);

runSocketListener(Store);

export default Store;
